var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('base-banner',{attrs:{"id":"36"}}),_c('base-detail',{attrs:{"title":_vm.detail.title,"date":_vm.detail.date,"img":_vm.detail.default_img,"content":_vm.detail.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }